import { fetchPromoSearchTypes } from 'shared/services/fetchPromoSearchTypes';
import { TAsyncThunkAction } from 'shared/types/redux';
import { setPromoSearchTypes } from 'shared/slices/promoSearchTypes/slice';
import { setJsonQuery } from 'shared/slices/jsonQuery';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { selectPromoSearchTypes } from 'shared/selectors/jsonQuery/selectPromoSearchTypes';
import { TLocation } from 'shared/types/location';
import { setTerms } from '../../../packages/JsonQuery';
import { prepareRegionId } from './prepareRegionId';

export const updatePromoSearchTypes =
  (nextLocation: TLocation): TAsyncThunkAction =>
  async (dispatch, getState, context) => {
    const state = getState();

    if (!nextLocation) {
      return;
    }

    const regionId = prepareRegionId(nextLocation);

    const subdomain = context.custom.subdomain;

    const promoSearchTypes = await fetchPromoSearchTypes(context, { subdomain, regionId });

    if (!promoSearchTypes) {
      return;
    }

    dispatch(setPromoSearchTypes(promoSearchTypes));

    // Получаем текущие выбранные фильтры
    const currentJsonQuery = selectJsonQuery(state);
    const currentPromoSearchTypeValues = selectPromoSearchTypes(state);

    if (!currentPromoSearchTypeValues?.length) {
      return;
    }

    // Получаем все доступные значения из новых данных
    const availableValues = new Set<string>([
      ...promoSearchTypes.discount.map(item => item.value),
      ...promoSearchTypes.mortgage.map(item => item.value),
    ]);

    // Фильтруем только те значения, которые доступны в новом регионе
    const filteredValues = currentPromoSearchTypeValues.filter(value => availableValues.has(value));

    // Обновляем jsonQuery только если есть изменения
    if (filteredValues.length === currentPromoSearchTypeValues.length) {
      return;
    }

    const nextJsonQuery =
      filteredValues.length > 0
        ? setTerms('promo_search_types')(currentJsonQuery)(filteredValues)
        : { ...currentJsonQuery, promo_search_types: undefined };

    dispatch(setJsonQuery(nextJsonQuery));
  };
